import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24Bookmark1 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M16.703 2.302 7.02 2.301A2.795 2.795 0 0 0 4.3 4.972v15.65a.89.89 0 0 0 1.265.805l.128-.078L11.95 16.6l6.246 4.749.142.084a.9.9 0 0 0 1.26-.765L19.6 4.972a2.79 2.79 0 0 0-2.896-2.67zm-9.66 1.399 9.825.002a1.393 1.393 0 0 1 1.333 1.328L18.2 19.593l-6.25-4.75-6.25 4.744V5.002c.03-.7.619-1.279 1.343-1.301"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24Bookmark1$1 = Svg24Bookmark1;

export { Svg24Bookmark1$1 as default };
